// @ts-nocheck
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import constants from "@store/constants";
import getCanOnlyOrderSample from "@store/Framework/Common/Utilities/samples/getCanOnlyOrderSample";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const AfterPopulateApiParameter = createChainHandler("AfterPopulateApiParameter", chain, props => {
    const state = props.getState();

    props.apiParameter.cartLines?.forEach(cartLine => {
        const orderLine = props.apiResult?.order.orderLines?.find(
            x => x.productId === cartLine.productId && x.unitOfMeasure === cartLine.unitOfMeasure,
        );

        if (orderLine && getCanOnlyOrderSample(state, orderLine)) {
            cartLine.unitOfMeasure = constants.sampleUOM;
        }
    });
});

addToChainAfter(chain, PopulateApiParameter, AfterPopulateApiParameter);
